export default "__VITE_ASSET__tNqdCBOt__"